/*
 *
 * Copyright (C) 2021 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import InsightCountSchema, { InsightCount } from '../../schemas/action/InsightCountSchema'

export default function InsightCountVo(initData: unknown = {}): InsightCount {
  return InsightCountSchema.validateSync(initData)
}
